import React from 'react';
import { Result } from 'antd';
import { useAuthStore } from '@/store/authStore';
import { canEnterOperatorVendorDirectory } from '@/store/vendorAccess';

const OperatorOnlyRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { authorization } = useAuthStore();
  if (authorization?.unrestricted) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="This view is for Operators. Admins manage vendors from the Vendors page."
      />
    );
  }
  const allowed = canEnterOperatorVendorDirectory(authorization);
  if (!allowed) {
    return (
      <Result
        status="403"
        title="403"
        subTitle="You need a role that can view your business unit's vendors."
      />
    );
  }
  return <>{children}</>;
};

export default OperatorOnlyRoute;
